<template>
    <!-- The Modal -->
    <b-modal
        id="recommended-vehicle-model-offer"
        title="Send Vehicle Offer"
        v-model="modalOpen"
        no-fade
        size="lg"
        @change="onModalChange"
        @hide="onModalHide"
        @show="onModalChange">
        <template v-slot:modal-footer>
            <b-btn @click="modalOpen = false">Cancel</b-btn>
            <b-btn :disabled="!selectedUserIds.length ? (customRecipients === '') ? true : false : false" :title="selectedUserIds.length ? '' : 'Add some users to send.'" @click="submitOffer()">Send</b-btn>
        </template>
        <template v-if="recommend">
            <span class="checkbox">
                <input type="checkbox" name="notify" id="notify" v-model="notify"/>
                <label for="notify">Also notify customers by email</label>
            </span>
        </template>
        <div>
            <label>
                Offer email subject
            </label>
            <b-form-input
                class="mb-2"
                id="offer_subject_send"
                type="text"
                v-model="offer_subject"
                :placeholder="offer_subject_placeholder">
            </b-form-input>
        </div>
        <div>
            Select the people you want to offer this car to.
        </div>
        <div v-if="notify" class="">
            <div class="row">
                <div class="col-md-12">
                    <template v-if="editTemplate">
                        <small v-html="instructions"></small>
                        <editor :api-key="TINYMCE_API_KEY" :init="editor_settings" v-model="main_content"/>
                    </template>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 input-area">
                <label for="custom-recipients">
                    Send To
                    <a v-if="$userIsAdmin()" v-b-toggle.collapse-email-input>[new email]</a>
                </label>
                <b-collapse id="collapse-email-input" :visible="!$userIsAdmin()">
                    <input
                        type="text"
                        name="userName"
                        placeholder="Input emails separated by commas."
                        id="custom-recipients"
                        v-model="customRecipients"
                        class="textbox"
                    />
                </b-collapse>
            </div>
        </div>
        <b-table
                v-if="viewListOfUsers"
                class="list-table"
                :sort-by.sync="sort_by"
                :sort-desc.sync="sort_desc"
                :fields="fields"
                :items="users"
                show-empty
        >
            <template v-slot:empty="scope">
                Search below to add users.
            </template>
            <template v-slot:cell(checkbox)="data">
                <i class="fa fa-times text-danger cursor-pointer" @click="removeUser(data.item.id)" title="Remove from list"></i>
            </template>
            <template v-slot:cell(region)="data">
                <span v-if="data.item.region && data.item.region.name">{{data.item.region.name}}</span>
            </template>
            <template v-slot:cell(assignedrep)="data">
                <span v-if="data.item.sales_rep && data.item.sales_rep.name">{{data.item.sales_rep.name}}</span>
            </template>
        </b-table>
        <div class="row">
            <div class="col-md-6 input-area">
                <input ref="user_search_input" type="text" name="userName"
                       placeholder="Start typing to search"
                       v-on:keyup="getUsers()" id="userName" v-model="userName"
                       class="textbox"/>
            </div>
            <div class="col-md-6 input-area">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <b-checkbox v-model="filterByRep" @change="getUsers">Filter by rep</b-checkbox>
                        </div>
                        <div v-if="repList && repList.length" class="col-md-6">
                            <b-checkbox v-model="sendFromRep">Send from rep</b-checkbox>
                        </div>
                        <div v-if="repList && repList.length" class="col-md-12">
                            <b-select v-if="sendFromRep" v-model="fromRep" :options="repList" text-field="name" value-field="id">
                                <b-form-select-option :value="null" disabled>-- Select from rep --</b-form-select-option>
                            </b-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row user-detail" v-if="getUserList && getUserList.length">
            <div class="col-md-12" v-for="user in getUserList">
                <div class="row detail">
                    <div class="col-md-6">
                        <span class="member-name">{{user.name}}</span> <span
                        v-if="user.company">({{user.company.name}})</span>
                    </div>
                    <div class="col-md-6 link">
                        <a @click="saveToList(user)" class="save-list">Add</a>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
    import { mapState, mapActions } from 'vuex'
    import {objLookup, numberWithCommas} from '../util/common'
    import _ from 'underscore'
    import draggable from 'vuedraggable'
    import Multiselect from "vue-multiselect";
    import {collect} from "collect.js";

    export default {
        props: {
            selectedVehicles: [String, Number, Boolean, Array],
            vehicle_id: Number,
            cacheKey: String,
            recommend: Boolean,
            value: [String, Number, Boolean, Array],
            vehicle: {
                type: Object,
                default: {}
            }
        },
        components: {
            draggable,
            Editor,
        },
        created(){
            this.getUserList = [];
            this.$store.dispatch('users/getUsers', {
                args: {
                    sort_by: 'company',
                    sort_asc: true,
                    per_page: 1000,
                    filter_by_status: 1,
                }});
            this.getReps();
            if (!this.recommend) {
                this.notify = true;
            }
        },
        mounted(){
        },
        data() {
            const vehicleLink = window.location.protocol + "//" + window.location.host + this.$route.path;
            return {
                getUserList: [],
                sort_by: 'first_name',
                userName: '',
                sort_desc: false,
                filterByRep: false,
                sendFromRep: false,
                userSearchCancelToken: null,
                offer_subject: this.vehicle.offer_subject,
                fromRep: null,
                changeImages: false,
                editTemplate: false,
                modalOpen: this.value,
                selected_search: null,
                repList: [],
                fields: [
                    {label: '',      key: 'checkbox'},
                    {label: 'Company',      key: 'company.name'},
                    {label: 'Name',         key: 'name'},
                    {label: 'Region',       key: 'region'},
                    {label: 'Assigned Rep', key: 'assignedrep'},
                ],
                instructions: '<i>{{greeting}} = "Hi, first_name"</i>',
                editor_settings: {
                    height: 500,
                    menubar: false,
                    placeholder: "",
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar_location: 'bottom',
                    toolbar: ['undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help']
                },
                //top_message: `We have a ${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model} that may work for you. Take a look at its details on our vehicle platform <a style="color: #C69200;" href="${vehicleLink}"><strong>here</strong></a>.`,
                bottomMessage: ``,
                //afterImageMessage: `Get in contact with your SBL representative to get more information on this offer today.`,
                notify: false,
                selectedUserIds: [],
                viewListOfUsers: true,
                users: [],
                customRecipients: ''
            }
        },
        computed: {
            ...mapState({
                // users: state => state.users.all,
                total: state => state.users.total,
            }),
            selectAll(){
                return this.selectedUserIds && this.users && this.selectedUserIds.length === this.users.length
            },
            offer_subject_placeholder(){
                return `${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model}` + (this.vehicle.grade ? ` / ${this.vehicle.grade}` : '')
            },
            offerImages(){
                const images = []
                if (this.vehicle.front_image_offer_send) {
                    images.push({
                        url: this.vehicle.images.front.large,
                        order: this.vehicle.front_image_order || 97,
                    })
                }
                if (this.vehicle.back_image_offer_send) {
                    images.push({
                        url: this.vehicle.images.back.large,
                        order: this.vehicle.back_image_order || 98,
                    })
                }
                if (this.vehicle.inside_image_offer_send) {
                    images.push({
                        url: this.vehicle.images.interior.large,
                        order: this.vehicle.inside_image_order || 99,
                    })
                }
                if (this.vehicle.extra_images && this.vehicle.extra_images.length){
                    this.vehicle.extra_images.forEach(img => {
                        if (img.offer_send) {
                            images.push({
                                id: img.id,
                                url: img.url,
                                order: img.sort_order || 50,
                            })
                        }
                    })
                }
                if (this.vehicle.sheet_image_offer_send) {
                    images.push({
                        url: this.vehicle.images.sheet.large,
                        order: this.vehicle.sheet_image_order || 100,
                    })
                }
                //sort by order
                images.sort((a, b) => {
                    //put selected ones first
                    return a.order - b.order;
                })

                return collect(images).pluck('url');
            },
        },
        watch: {
            value(){
                this.modalOpen = !!this.value;
                if (!this.modalOpen) {
                    this.selectedUserIds = [];
                    this.users = [];
                    this.selected_search = null;
                    this.userName = '';
                    this.getUserList = [];
                }
            }
        },
        methods: {
            getDefaultMessage() {
                let fuel_type = ''
                const logo_url = window.location.origin + '/images/sbl-logo.png?ver=2'
                const vehicle = this.vehicle;
                const mileage = numberWithCommas(this.vehicle.mileage);
                const offer_price = '$'+numberWithCommas(this.vehicle.offer_price);
                const retail_price = '$'+numberWithCommas(this.vehicle.retail_price);
                const condition = this.vehicle.condition === '' ? 'N/A' : this.vehicle.condition;
                const offer_note = this.vehicle.offer_note ? this.vehicle.offer_note : '';
                let ac = '';
                const vehicle_grade = vehicle.grade ? vehicle.grade : '';
                const vehicle_equipment = vehicle.equipment ? vehicle.equipment : '';
                if (this.vehicle.ac) {
                    ac = this.vehicle.ac
                }
                switch (this.vehicle.fuel_type) {
                    case 'P':
                    case 'Petrol':
                        fuel_type = 'Petrol'
                        break;
                    case 'E':
                    case 'Electric':
                        fuel_type = 'Electric'
                        break;
                    case 'D':
                    case 'Diesel':
                        fuel_type = 'Diesel'
                        break;
                    case 'H':
                    case 'Hybrid':
                        fuel_type = 'Hybrid'
                        break;
                }

                return `<table class="content-container" width="100%" cellpadding="0" cellspacing="0" border="0">

    <tr>
        <td width="100%">
            <table cellpadding="0" cellspacing="0" border="0" width="100%">
                <tr>
                    <td height="20" style="height: 20px; line-height: 20px;">
                        &nbsp;
                    </td>
                </tr>
                <tr>
                    <td>
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td width="20px" style="width: 20px;"></td>
                                <td>
                                    <p style="font-size: 16pt; font-family: Verdana,sans-serif; line-height: 17px; font-style: italic;" >
                                        <strong>
                                            ${vehicle.year}
                                            ${vehicle.make}
                                            <span style="color: #0488DF;">${vehicle.model} ${vehicle_grade}</span>
                                        </strong>
                                        <br />
                                        <br />
                                        <br />
                                        <br /><br />
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td height="20" style="height: 20px; line-height: 20px;">
                        &nbsp;
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td>
            <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                    <td width="20px" style="width: 20px;"></td>
                    <td>
                        <table class="send-offer-detail" width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td>
                                    <table width="100%" cellspacing="0" cellpadding="0" border="0">
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;"><strong>Make/Model:</strong></td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;"><strong>${vehicle.make} ${vehicle.model}</strong></td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;">Chassis:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">${vehicle.chassis}</td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;">Year:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">${vehicle.year}</td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;">Mileage:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">${mileage} kms</td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;">Colour:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">${vehicle.color}</td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;">Engine:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">${vehicle.engine_capacity}cc</td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;">Transmission:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">${vehicle.transmission}</td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;font-weight: bold;padding-bottom: 7px;"><strong>Fuel:</strong></td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;font-weight: bold;padding-bottom: 7px;">
                                                <strong>${fuel_type}</strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;"><strong>Condition:</strong></td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">
                                                <strong>${condition}</strong>
                                            </td>
                                        </tr>
                                        <tr style="vertical-align: top;">
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 7px;">AC:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 7px;">${ac}</td>
                                        </tr>
                                        <tr style="vertical-align: top;">
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 20px;">Equipment:</td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 20px;">${vehicle_equipment}</td>
                                        </tr>
                                        <tr style="vertical-align: top;">
                                            <td width="150" style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; width: 150px;padding-bottom: 20px;"><strong>Notes:</strong></td>
                                            <td style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px;padding-bottom: 20px;">${offer_note}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <table cellpadding="0" cellspacing="0" border="0" width="100%">
                            <tr>
                                <td>
                                    <table cellpadding="0" cellspacing="0" border="0" style="padding:0px;margin:0px;width:100%;">
                                        <tr><td colspan="3" style="padding:0px;margin:0px;font-size:20px;height:20px;" height="20">&nbsp;</td></tr>
                                        <tr>
                                            <td style="padding:0px;margin:0px;">&nbsp;</td>
                                            <td style="padding:0px;margin:0px;" width="850"><!-- max width goes here -->

                                                <p style="font-size: 10pt; font-family: Verdana,sans-serif; line-height: 17px; color: #0488DF; text-align: center;">
                                                    <strong>Will be ${offer_price} at your door un-complied - would look great at ${retail_price} retail with these details.</strong>
                                                </p>
                                                <br />
                                                <br />
                                                <p style="font-size: 8pt; font-family: Verdana,sans-serif; line-height: 17px; text-align: center; font-style: italic;">
                                                    A little extra will get the car anywhere in NZ if you're outside of the 3 main ports.
                                                </p>
                                            </td>
                                            <td style="padding:0px;margin:0px;">&nbsp;</td>
                                        </tr>
                                        <tr><td colspan="3" style="padding:0px;margin:0px;font-size:20px;height:20px;" height="20">&nbsp;</td></tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td height="20" style="height: 20px; line-height: 20px;">
                                    &nbsp;
                                </td>
                            </tr>
                            <tr>
                                <td height="20" style="height: 20px; line-height: 20px;font-size: 8pt; font-family: Verdana,sans-serif;">
                                    <strong>
                                        Please Note: This offer does not include the $225 BMSB Heat Treatment surcharge.
                                        MPI has determined that the BMSB season runs from September 1st until April 30th,
                                        however this is subject to change at any time by MPI. Should Heat Treatment be
                                        required for this vehicle, the related BMSB Heat Treatment charge will be applied
                                        at the time of final invoice.
                                    </strong>
                                </td>
                            </tr>
                            <tr>
                                <td height="20" style="height: 20px; line-height: 20px;">
                                    &nbsp;<br />
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
</table>

                `;
            },
            async getReps(){
                try {
                    const reps = await this.$store.dispatch('users/getUsers', {args:{
                            sort_by: 'company',
                            sort_asc: true,
                            per_page: 100,
                            filter_by_roles: [3, 4],
                        }});
                    if (reps && reps.data && reps.data.length) {
                        const repList = [];
                        reps.data.forEach(rep => {
                            if (rep.privileges && rep.privileges.enable_signature && rep.signature) {
                                repList.push(rep)
                            }
                        })
                        this.repList = repList;
                    }
                } catch (e) {
                    console.warn(e)
                }
            },
            extraImagesClass(image) {
                const classNames = ['col-md-3 extra-image-col'];
                if (this.selectedImages.indexOf(image) !== -1) {
                    classNames.push('selected')
                }
                return classNames.join(' ')
            },
            onSelectAllClick(){
                if (this.selectAll) {
                    this.selectedUserIds = []
                } else {
                    let uids = []
                    this.users.forEach(user => {
                        uids.push(user.id)
                    })
                    this.selectedUserIds = uids
                }
            },
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            onModalHide(){
                this.editTemplate = false
                this.onModalChange();
            },
            onModalChange(){
                this.$emit('input', this.modalOpen);
            },
            async submitOffer(){
                try {
                    const args = {
                        user_ids: this.selectedUserIds,
                        custom_recipients: this.customRecipients,
                        vehicle_id: this.vehicle_id,
                        notify: this.notify,
                        recommend: this.recommend,
                        cache_key: this.cacheKey,
                        main_content: this.getDefaultMessage(),
                        offer_subject: this.offer_subject,
                    }
                    if (this.cacheKey) {
                        args.cache_key = this.cacheKey
                    }
                    if (this.sendFromRep && this.fromRep) {
                        args.from_user = this.fromRep
                    }
                    args.email_images = this.offerImages
                    const {data} = this.$store.dispatch('users/storeSendOffer', args)
                    this.$notify({
                        title: 'Success',
                        message: data || 'Offer successful.',
                        type: 'success'
                    });
                    this.modalOpen = false;
                } catch (err) {
                    console.warn('err', err)
                    this.modalOpen = false;
                    this.$notify({
                        title: 'Error',
                        message: res.message || 'Offer failed.',
                        type: 'error'
                    });
                }
            },

            getUsers(){
                if (this.userName || this.filterByRep) {
                    const args = {
                        filter_by_status: 1,
                        sort_asc: 1
                    }
                    if (this.userName) {
                        args.searchUser = this.userName
                    }
                    if (this.filterByRep) {
                        args.filter_by_roles = [1,3]
                    }
                    if (this.userSearchCancelToken) {
                        this.userSearchCancelToken.cancel('Request cancelled for new request')
                    }
                    this.userSearchCancelToken = this.axios.CancelToken.source();
                    try{
                        this.$store.dispatch('users/getUsers', {
                            args,
                            cancelToken: this.userSearchCancelToken
                        }).then(response => {
                            let users = []
                            response.data.forEach(user => {
                                if (this.selectedUserIds.indexOf(user.id) === -1) {
                                    users.push(user)
                                }
                            })
                            this.getUserList = users
                        });
                    } catch (e) {
                        console.warn('VehicleSendOfferModal/getUsers catch', e)
                    }
                } else {
                    this.getUserList = [];
                }
            },
            resetRecommendedUser(){
                this.selectedUserIds = [];
            },
            researchForPerson(){
                this.viewListOfUsers = true;
            },
            removeUser(user_id){
                let found_index = null
                this.users.forEach((user, index) => {
                    if (user.id === user_id) {
                        found_index = index
                    }
                })
                if (found_index !== null) {
                    this.users.splice(found_index, 1)
                }
                this.updateSelectedUserIds()
            },
            saveToList(user){
                this.users.push(user)
                this.getUserList = this.getUserList.filter((u) => {
                    return u.id !== user.id
                })
                this.updateSelectedUserIds()
            },
            updateSelectedUserIds(){
                let ids = [];
                this.users.forEach(user => {
                    ids.push(user.id)
                })
                this.selectedUserIds = ids
            }

        }
    }
</script>
<style scoped lang="scss">
    @import "./resources/sass/mixins";
    @import "./resources/sass/variables";
    .extra-images{
        .extra-image-col{
            opacity: 0.5;
            img{
                border: 2px solid white;
            }
            &.selected{
                opacity: 1;
                img{
                    border: 2px solid $blue;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/VehicleSendOfferModal.vue